const bundle = {
  close: () => 'Затваряне',
  error: () => 'Грешка',
  warn: () => 'Предупреждение',
  info: () => 'Информация',
  confirmation: () => 'Потвърждение',
  progressIndeterminate: () => 'Изпълнява се',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Между ' + p['FROM_SECTION'] + ' и ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Няма намерен съответстващ раздел.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Натиснете Enter, за да изберете стойност.',
  indexer_touchInstructionText: () =>
    'Натиснете два пъти и задръжте, за да влезете в режима с жестове, след което плъзнете нагоре или надолу, за да коригирате стойността.',
  inputPassword_show: () => 'Показване на парола',
  inputPassword_hide: () => 'Скриване на парола',
  inputPassword_hidden: () => 'Паролата е скрита',
  formControl_clear: () => 'Изчистване',
  formControl_loading: () => 'Зареждане',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Надвишена е максималната дължина от ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Остават ' + p['CHARACTER_COUNT'] + ' знака.',
  select_noMatchesFound: () => 'Няма намерени съвпадения.',
  select_oneMatchFound: () => 'Намерено е едно съвпадение',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Открити са ' + p['TOTAL_SIZE'] + ' съвпадения',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Открити са ' + p['TOTAL_SIZE'] + ' или повече съвпадения',
  selectMultiple_showSelectedValues: () => 'Показване само на избраните стойности.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Избрани са ' + p['VALUE_COUNT'] + ' стойности.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Полето е с отметка',
  selector_unselected: () => 'Полето е без отметка',
  userAssistance_learnMore: () => 'Научете повече',
  userAssistance_required: () => 'Задължително',
  filePicker_singleFileUploadError: () => 'Качвайте по един файл наведнъж',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Не можете да качвате файлове от тип ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Не можете да качвате файлове от тип: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'неизвестен',
  filePicker_dropzonePrimaryText: () => 'Плъзгане и пускане',
  filePicker_dropzoneSecondaryText: () => 'Изберете файл или го пуснете тук',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Изберете или пуснете файлове тук',
  filePicker_addFiles: () => 'Добави файлове',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Увеличаване',
  inputNumber_decrease: () => 'Намаляване',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Няма елементи за показване',
  message_navigationFromMessagesRegion: () =>
    'Влизане в областта за съобщения. Натиснете F6, за да се върнете обратно към предишния фокусиран елемент.',
  message_navigationToMessagesRegion: () =>
    'В областта за съобщения има нови съобщения. Натиснете F6, за да навигирате до областта за най-скорошно съобщение.',
  messageToast_allMessagesClosed: () => 'Всички тост съобщения са затворени.'
};
export default bundle;
